import { Directive, TemplateRef } from '@angular/core';
import { PageHeaderComponent } from './page-header.component';

@Directive({
  selector: '[mriSharedPageHeaderToolbar]',
  standalone: true
})
export class PageHeaderToolbarDirective {
  constructor(toolbarTemplate: TemplateRef<never>, pageHeader: PageHeaderComponent) {
    pageHeader.toolbarTemplate = toolbarTemplate;
  }
}
